import Colors from '@constants/Colors';
import { Box, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton, Typography } from '@mui/material';

type Props = {
    src: string;
    title?: string;
    onPrev?: () => void;
    onNext?: () => void;
    onClose?: () => void;
} & DialogProps;

const PreviewImage = ({ title, src, onClose, ...props }: Props) => {
    // const { isMobile } = useWindowSize();
    return (
        <Dialog
            {...props}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    // p: 3,
                    // m: isMobile ? 1 : 0,
                    margin: {
                        xs: 1,
                        sm: 0,
                    },
                    borderRadius: '12px',
                    // ...(isMobile && {
                    //     maxWidth: '100% !important',
                    //     width: 'calc(100% - 16px) !important',
                    // }),
                    maxWidth: {
                        xs: '100% !important',
                        sm: 'calc(100% - 16px) !important',
                    },
                    width: {
                        xs: '100% !important',
                        sm: 'calc(100% - 16px) !important',
                    },
                },
            }}>
            <DialogTitle>
                <IconButton
                    // containerStyle={{
                    //     position: 'absolute',
                    //     top: 6,
                    //     right: 6,
                    //     zIndex: 1,
                    //     background: ' #FFF',
                    //     borderRadius: '50%',
                    // }}
                    // buttonStyle={{
                    //     paddingVertical: 8,
                    //     paddingHorizontal: 10,
                    // }}
                    // mode="text"
                    // dark
                    onClick={() => { onClose?.() }}
                >
                    <i className="fi fi-br-cross" style={{ fontSize: 24, color: Colors.NEUTRAL_BLACK }} />
                </IconButton>
                {(props.onPrev || props.onNext) && (
                    <nav style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                        {/* prev */}
                        {props.onPrev && (
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: 0,
                                    transform: 'translateY(-50%)',
                                    backgroundColor: Colors.NEUTRAL_WHITE,
                                    // width: isMobile ? 24 : 48,
                                    // height: isMobile ? 24 : 48,
                                    width: {
                                        xs: 24,
                                        sm: 48,
                                    },
                                    height: {
                                        xs: 24,
                                        sm: 48,
                                    },
                                }}
                                onClick={props.onPrev}>
                                <i className="fi fi-br-left" />
                            </IconButton>
                        )}
                        {/* next */}
                        {props.onNext && (
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: 0,
                                    transform: 'translateY(-50%)',
                                    backgroundColor: Colors.NEUTRAL_WHITE,
                                    // width: isMobile ? 24 : 48,
                                    // height: isMobile ? 24 : 48,
                                    width: {
                                        xs: 24,
                                        sm: 48,
                                    },
                                    height: {
                                        xs: 24,
                                        sm: 48,
                                    },
                                }}
                                onClick={props.onNext}>
                                <i className="fi fi-br-right" />
                            </IconButton>
                        )}
                    </nav>
                )}
            </DialogTitle>
            <DialogContent>
                <Box
                    p={2}
                    style={{
                        height: 'calc(100vh - 300px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        gap: 8,
                    }}>
                    <img alt={title} src={src} style={{ maxHeight: '100%', maxWidth: '100%' }} />
                    <Typography>
                        {title}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions></DialogActions>
        </Dialog>
    );
};

export default PreviewImage;
